import React from 'react';

/**
 * Keeps track of whether or not something is disabled. Useful to pass disabled status deeply within nested form
 * components.
 * @type {import('react').Context}
 */
export default React.createContext(false);
